import Home from "./pages/Home";
import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import Ilanlarim from './pages/Ilanlarim';
import SaticiProfil from './pages/Satici_profil';
import Favoriler from './pages/Favoriler';
import Ilan_detay_login from './pages/Ilan_detay_login';
import Ilan_duzenle from './pages/Ilan_duzenle';
import Arama from './pages/Arama';
import Profil from './pages/Profil';
import Mesajlar from './pages/Mesajlar';
import ConversationDetail from './pages/ConversationDetail';
import Kayit from './pages/Kayit';
import Giris from './pages/Giris';
import Ilan_ver from './pages/Ilan_ver';
import Ilan_detay from './pages/Ilan_detay';
import Ilanlarim_kurumsal from './pages/Ilanlarim_kurumsal';
import Index_login from './pages/Index_login';
import Profil_kurumsal from './pages/Profil_kurumsal';
import Satici_profil_kurumsal from './pages/Satici_profil_kurumsal';
import SupportPage from './pages/SupportPage';
import Gonderiler from './pages/Gonderiler';
import Gonderilerim from './pages/Gonderilerim';
import KaydedilenGonderiler from './pages/KaydedilenGonderiler';
import Masaustu_tavsiyeler from './pages/Masaustu_tavsiyeler';
import AdminLayout from './components/admin/AdminLayout';
import UserManagementPage from './pages/admin/UserManagementPage';
import CorporateUserManagementPage from './pages/admin/CorporateUserManagementPage';
import ListingManagementPage from './pages/admin/ListingManagementPage';
import DataManagementPage from './pages/admin/DataManagementPage';
import Notifications from './pages/Notifications';
import SifremiUnuttum from './pages/SifremiUnuttum';
import SifremiUnuttumYeniSifre from './pages/SifremiUnuttumYeniSifre';
import EmailDogrula from './pages/EmailDogrula';
import SifreDegistir from './pages/SifreDegistir';
import SupportTicketDetailPage from './pages/SupportTicketDetailPage';
import AdminSupportTicketsPage from './pages/admin/AdminSupportTicketsPage';
import AdminSupportTicketDetailPage from './pages/admin/AdminSupportTicketDetailPage';
import ModerationDashboardPage from './pages/admin/ModerationDashboardPage';
import GoogleSuccess from './pages/GoogleSuccess';
import PolicyPage from './pages/PolicyPage';
import UtmSourcesPage from './pages/admin/UtmSourcesPage';
import AdminActionLogPage from './pages/admin/AdminActionLogPage';
import { useUtmVisitRecorder } from './hooks/useUtmVisitRecorder';

const UtmVisitRecorderMount: React.FC = () => {
  useUtmVisitRecorder();
  return null;
};

const AppRoutes: React.FC = () => {
  return (
    <>
    <UtmVisitRecorderMount />
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/index_login" element={<Index_login />} />
      <Route path="/ilanlarim" element={<Ilanlarim />} />
      <Route path="/ilanlarim-kurumsal" element={<Ilanlarim_kurumsal />} />
      <Route path="/satici-profil/:id" element={<SaticiProfil />} />
      <Route path="/satici-profil-kurumsal/:id" element={<Satici_profil_kurumsal />} />
      <Route path="/favoriler" element={<Favoriler />} />
      <Route path="/ilan-detay/:id" element={<Ilan_detay />} />
      <Route path="/ilan-detay-login/:id" element={<Ilan_detay_login />} />
      <Route path="/ilan-detay-kurumsal/:id" element={<Ilan_detay />} />
      <Route path="/ilan-duzenle/:id" element={<Ilan_duzenle />} />
      <Route path="/arama" element={<Arama />} />
      <Route path="/profil" element={<Profil />} />
      <Route path="/profil-kurumsal" element={<Profil_kurumsal />} />
      <Route path="/mesajlar" element={<Mesajlar />} />
      <Route path="/conversations/:id" element={<ConversationDetail />} />
      <Route path="/kayit" element={<Kayit />} />
      <Route path="/giris" element={<Giris />} />
      <Route path="/ilan-ver" element={<Ilan_ver />} />
      <Route path="/teknik-destek" element={<SupportPage />} />
      <Route path="/teknik-destek/ticket/:id" element={<SupportTicketDetailPage />} />
      <Route path="/gonderiler" element={<Gonderiler />} />
      <Route path="/gonderilerim" element={<Gonderilerim />} />
      <Route path="/kaydedilen-gonderiler" element={<KaydedilenGonderiler />} />
      <Route path="/masaustu_tavsiyeler" element={<Masaustu_tavsiyeler />} />
      <Route path="/Masaustu_tavsiyeler" element={<Masaustu_tavsiyeler />} />
      <Route path="/laptop-tavsiyeler" element={<Masaustu_tavsiyeler />} />
      <Route path="/donanim-tavsiyeler" element={<Masaustu_tavsiyeler />} />
      <Route path="/admin-panel" element={<AdminLayout />}>
        <Route index element={<Navigate to="user-management" replace />} />
        <Route path="user-management" element={<UserManagementPage />} />
        <Route path="corporate-user-management" element={<CorporateUserManagementPage />} />
        <Route path="listing-management" element={<ListingManagementPage />} />
        <Route path="data-management" element={<DataManagementPage />} />
        <Route path="support-tickets" element={<AdminSupportTicketsPage />} />
        <Route path="support-tickets/:id" element={<AdminSupportTicketDetailPage />} />
        <Route path="moderation" element={<ModerationDashboardPage />} />
        <Route path="utm-kaynaklari" element={<UtmSourcesPage />} />
        <Route path="admin-logs" element={<AdminActionLogPage />} />
      </Route>
      <Route path="/notifications" element={<Notifications />} />
      <Route path="/sifremi-unuttum" element={<SifremiUnuttum />} />
      <Route path="/sifremi-unuttum/yeni-sifre" element={<SifremiUnuttumYeniSifre />} />
      <Route path="/email-dogrula" element={<EmailDogrula />} />
      <Route path="/sifre-degistir" element={<SifreDegistir />} />
      <Route path="/auth/google-success" element={<GoogleSuccess />} />
      {/* Legacy / alternate policy paths → normalized Turkish slugs */}
      <Route path="/terms-of-service" element={<Navigate to="/kullanici-sozlesmesi" replace />} />
      <Route path="/privacy-policy" element={<Navigate to="/gizlilik-politikasi" replace />} />
      <Route path="/listing-agreement" element={<Navigate to="/ilan-sozlesmesi" replace />} />
      <Route path="/gizlilik-sozlesmesi" element={<Navigate to="/gizlilik-politikasi" replace />} />
      <Route path="/kullanici-sozlesmesi" element={<PolicyPage />} />
      <Route path="/gizlilik-politikasi" element={<PolicyPage />} />
      <Route path="/ilan-sozlesmesi" element={<PolicyPage />} />
      <Route path="/cerez-politikasi" element={<PolicyPage />} />
      <Route path="/yeni-uye-rehberi" element={<PolicyPage />} />
      <Route path="/uyelik-sozlesmesi-bireysel-hesap" element={<PolicyPage />} />
      <Route path="/uyelik-sozlesmesi-kurumsal-hesap" element={<PolicyPage />} />
      <Route path="/site-kullanim-kosullari" element={<PolicyPage />} />
      <Route path="/kisisel-verilerin-islenmesi" element={<PolicyPage />} />
      <Route path="/on-bilgilendirme-formu" element={<PolicyPage />} />
      <Route path="*" element={
        <div className="min-vh-100 d-flex flex-column align-items-center justify-content-center" style={{ backgroundColor: 'var(--sb-bg-muted)' }}>
          <i className="fas fa-exclamation-circle fa-4x text-muted mb-4" />
          <h1 className="fw-bold mb-2">404</h1>
          <p className="text-muted mb-4">Aradığınız sayfa bulunamadı.</p>
          <a className="btn btn-primary" href="/">Ana Sayfaya Dön</a>
        </div>
      } />

    </Routes>
    </>
  );
};

export default AppRoutes; 